export default __webpack_public_path__ + "static/MainPageBanner-3c20969d9e05739fd7c5f91518085d77.webp";